var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav_wrap_add"},[_c('div',{staticClass:"nav_wrap"},[_c('div',{staticClass:"nav"},_vm._l((_vm.about_nav),function(item,index){return _c('span',{key:index,class:{active:_vm.$route.path.slice(0,8) === item.path.slice(0,8)},on:{"click":function($event){return _vm.nav_link(item.path)}}},[_vm._v(_vm._s(item.name))])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e159fc3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/about_nav.vue
// module id = null
// module chunks = 